<template>
  <section class="service-header">
    <div class="container">
      <div class="service-header-info">
        <h3 class="title">
          {{ $t(props.title) }}
        </h3>
        <p class="text" v-if="typeof props.subtitle !== 'string'">
          {{ props.subtitle[0] }}
          <span @click="isShowFeedBackModal = true">{{
            props.subtitle[1]
          }}</span>
        </p>
        <p v-else class="text">
          {{ $t(props.subtitle) }}
        </p>
      </div>
      <div class="service-search">
        <ui-input
          v-model="searchInput"
          class="input-search"
          :clearable="true"
          input-class="input"
          borderless
          dense
          :placeholder="$t(inputPlaceHolder)"
          @input="updateValue($event.target.value)"
          @keydown.enter="serviceSearchClick"
          @clear="serviceSearchClick"
        >
          <template #left-icon>
            <IconSearch />
          </template>
        </ui-input>
        <ui-button
          color="primary"
          class="service-search-button"
          @click="serviceSearchClick"
        >
          {{ $t('search') }}
        </ui-button>
      </div>
    </div>
    <lazy-feed-back-modal
      v-model:show="isShowFeedBackModal"
      v-if="isShowFeedBackModal"
    />
  </section>
</template>

<script setup lang="ts">
import IconSearch from '~/assets/svg/gray-search.svg';

const props = defineProps<{
  modelValue: string;
  title: string;
  subtitle: string;
  inputPlaceHolder: string;
}>();

const emits = defineEmits(['searchHandler', 'update:modelValue']);

function updateValue(value: string) {
  emits('update:modelValue', value);
}

const searchInput = computed({
  get() {
    return props.modelValue;
  },
  set(v) {
    emits('update:modelValue', v);
  },
});

const isShowFeedBackModal = ref(false);

const serviceSearchClick = () => {
  emits('searchHandler', '');
};
</script>

<style scoped lang="scss">
.service-header {
  background: no-repeat url($static-url + '/images/sc-bg.webp') center;
  background-size: cover;
  padding: 176px 0 50px;
  margin-top: -200px;
  max-height: fit-content;
}

.service-header-info {
  color: var(--var-white-000);
  text-align: center;
  margin: 0 auto 64px auto;
  width: 100%;
  max-width: 684px;

  h3 {
    color: var(--var-white-000);
  }
  p {
    color: var(--var-white-000);
  }

  .title {
    font-weight: 700;
    font-size: 36px;
  }

  .text {
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.02em;

    span {
      cursor: pointer;
      color: var(--var-white-000);
      border-bottom: 1px solid var(--var-white-000);
    }
  }

  @media (max-width: $md) {
    margin: 30px auto 0px auto;
  }
}

.service-search {
  display: flex;
  justify-content: center;
  gap: 16px;

  .input-search {
    width: 100%;
    max-width: 622px;
    background-color: white;
    border-radius: 8px;
    .ui-input__icon {
      margin-top: 3px;
    }
  }

  .service-search-button {
    border-radius: 8px;
    //margin-left: 16px;
    text-transform: capitalize;
    padding: 0px 32px;
    font-weight: 600;
  }

  .service-search-button:hover {
    background: #005ba4;
  }

  @media (max-width: $md) {
    flex-direction: column;
  }
}
</style>
